import { render } from "./FreeModify.vue?vue&type=template&id=b698191e&scoped=true"
import script from "./FreeModify.vue?vue&type=script&lang=js"
export * from "./FreeModify.vue?vue&type=script&lang=js"

import "./FreeModify.vue?vue&type=style&index=0&id=b698191e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b698191e"]])

export default __exports__